import React from "react";
import { ModalsKeys } from "global";
import { useModal } from "hooks/useModal";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { EquipmentForm } from "../createUpdateEquipmentForm";

export const CreateUpdateEquipmentDialog = () => {
  const { isOpen, handleClose, data } = useModal(ModalsKeys.CreateUpdateEquipmentDialog);

  return (
    <Dialog fullWidth maxWidth="lg" open={isOpen} onClose={handleClose}>
      <DialogTitle title="Create new equipment" />

      <DialogContent>
        <EquipmentForm {...data} />
      </DialogContent>
    </Dialog>
  );
};
